export const navigateAndPulse = (route: string, targetSelector: string) => {
  if (route) {
    window.history.pushState({}, '', route)
    window.dispatchEvent(new PopStateEvent('popstate'))
  }
  requestAnimationFrame(() => {
    const el = document.querySelector<HTMLElement>(targetSelector)
    if (!el) return
    el.classList.add('orbit-landing-pulse')
    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    window.setTimeout(() => el.classList.remove('orbit-landing-pulse'), 1200)
  })
}
